<template>
    <div class="declined-info">
        <div class="block">
            <div class="mobile-accordion d-lg-none" @click="openAccordion">
                <span class="d-flex align-items-center"
                    ><i class="icon fal fa-info-circle"></i> {{ $t('results.declinedLenders.whyDeclined') }}</span
                >
                <i class="down-icon far fa-chevron-down"></i>
            </div>

            <div :class="['row d-lg-flex', !accordionOpen ? 'd-none' : 'd-flex']">
                <div class="col-12 col-lg-6 first-block d-flex justify-content-between align-items-center">
                    <i class="icon fal fa-info-circle d-none d-lg-flex"></i>
                    <span>{{
                        copy && copy.rejected_reasons_description
                            ? copy.rejected_reasons_description
                            : $t('results.declinedLenders.reasonsDeclined')
                    }}</span>
                </div>

                <div class="col-12 col-lg-6 mt-3 mt-lg-0" v-if="declinedReasons">
                    <ul class="declined-list">
                        <li class="d-flex align-items-start" v-for="(reason, index) in declinedReasons" :key="index">
                            <span class="count">{{ index + 1 }}</span
                            ><span>{{ reason.reason }}</span>
                        </li>
                    </ul>
                </div>

                <div class="col-12 col-lg-6 mt-3 mt-lg-0" v-else>
                    <ul class="declined-list">
                        <li class="d-flex">
                            <span class="count">1</span><span>{{ $t('results.declinedLenders.reason1') }}</span>
                        </li>

                        <li class="d-flex">
                            <span class="count">2</span><span>{{ $t('results.declinedLenders.reason2') }}</span>
                        </li>

                        <li class="d-flex">
                            <span class="count">3</span><span>{{ $t('results.declinedLenders.reason3') }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['copy'],
    computed: {
        declinedReasons: function () {
            return this.copy && this.copy.declined_reasons ? JSON.parse(this.copy.declined_reasons) : null
        },
    },
    data() {
        return {
            accordionOpen: false,
        }
    },
    methods: {
        openAccordion: function () {
            if (!this.accordionOpen) {
                this.trackEvent('event', {
                    eventCategory: 'button',
                    eventAction: 'click',
                    eventLabel: 'expanded-declined-lender-panel',
                    eventValue: this.$store.getters.fieldValue('loanAmount'),
                })
            }

            this.accordionOpen = !this.accordionOpen
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';
@import '~scss/settings/variables';

.declined-info {
    margin-top: 34px;

    .block {
        background: #f4f5f6;
        color: #4f5157;
        font-size: rem(14px);
        margin-bottom: 32px;
        margin-left: auto;
        margin-right: auto;
        padding: 14px 14px 14px 30px;
        position: relative;
        text-align: left;

        .mobile-accordion {
            align-items: center;
            display: flex;
            color: #242a2f;
            font-size: rem(17px);
            justify-content: space-between;
            padding: 8px 18px 8px 0;

            & > span {
                font-weight: bold;
            }

            .icon {
                margin-right: 12px;
                height: 27px;
                width: 27px;
            }
        }

        .first-block {
            color: #4f5157;
            font-size: rem(13px);

            @media screen and (min-width: $bp-large) {
                font-size: rem(19px);
            }

            .icon {
                position: relative;
                margin-right: 20px;
                height: 35px;
                width: 35px;
            }
        }

        .declined-list {
            li {
                color: #242a2f;
                font-size: rem(13px);
                margin-top: 13px;

                @media screen and (min-width: $bp-large) {
                    color: #808080;
                    font-size: rem(14px);
                    margin-top: 4px;
                }

                &:first-of-type {
                    margin-top: 0;
                }

                .count {
                    background-color: #808080;
                    border-radius: 100%;
                    color: #f4f5f6;
                    line-height: 20px;
                    margin-right: 10px;
                    padding: 0 7px;
                    text-align: center;
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .icon {
            color: var(--primary);
            font-size: rem(18px);
        }

        .down-icon {
            color: var(--primary);
        }
    }
}
</style>
